const breakpoints = {
  mobile: `@media (max-width: 768px)`,
  mobileSm: `@media (max-width: 420px)`,
};
export default breakpoints;
